/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getHydratedLessonEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedLesson',
  auth: 'app',
  fingerprint: '3CtkfG4GFjyL97xxcfdq5V9Ry1PAhX9Y',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getHydratedLessonsEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedLessons',
  auth: 'app',
  fingerprint: '1VzsgqKilCX0QCw7PA-FX5wP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getHydratedPartnerLessonsEarlyRequestRpc = {
  serviceName: 'com.hubspot.academy.catalog.rpc.LessonChirpService',
  rpcName: 'getHydratedPartnerLessons',
  auth: 'app',
  fingerprint: 'cuClgUvygV_Qcq4MTKcQHpwP6LXzGzX8',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};